// @ts-nocheck
/*
 * Port of cloudtelephony_frontend/src/router/context/AgentDashboardContext.js.
 * Byte-identical logic — extension only changes from .js to .tsx.
 */
import { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const AgentDashboardContext = createContext(null);

export function AgentDashboardProvider({ children }) {
  const [activeAgentReport, setActiveAgentReport] = useState(null);
  const [reportSelectionTick, setReportSelectionTick] = useState(0);

  const toggleAgentReport = useCallback((reportType) => {
    setReportSelectionTick((tick) => tick + 1);
    if (reportType === 'analytics') {
      setActiveAgentReport(null);
      return;
    }
    setActiveAgentReport((current) => (current === reportType ? null : reportType));
  }, []);

  const clearAgentReport = useCallback(() => {
    setActiveAgentReport(null);
  }, []);

  const value = useMemo(
    () => ({
      activeAgentReport,
      setActiveAgentReport,
      toggleAgentReport,
      clearAgentReport,
      reportSelectionTick,
    }),
    [activeAgentReport, toggleAgentReport, clearAgentReport, reportSelectionTick],
  );

  return (
    <AgentDashboardContext.Provider value={value}>
      {children}
    </AgentDashboardContext.Provider>
  );
}

export function useAgentDashboard() {
  return useContext(AgentDashboardContext);
}
